<template>
  <TresPerspectiveCamera
    ref="refCamera"
    :rotation="[0, 0, 0]"
    :position="[0, 0, z]"
    :fov="fov"
    :near="0.1"
    :far="z * 1.1"
  />
</template>

<script setup lang="ts">
import { LAYER_OUT } from "@/components/three/layers"

const props = defineProps({
  fov: {
    type: Number,
    default: 45,
  },
})

const emits = defineEmits([])

const { sizes, camera } = useTresContext()

const z = computed(() => {
  const vFov = props.fov * (Math.PI / 180)
  const z = sizes.height.value / (2 * Math.tan(vFov / 2))
  return z
})

const refCamera = ref(null)
const { registerCamera, setCameraActive } = useTresContext()

onMounted(() => {
  registerCamera(refCamera.value)
  refCamera.value.layers.set(LAYER_OUT)
})
const { onLoop } = useRenderLoop()
onLoop(() => {
  setCameraActive(refCamera.value)
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";
</style>
